import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** Returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns Batchfile File Type List
 @return { Array }
 */
 export const getBatchfileFileTypeList = state => state.batchfileFileTypeList

 /** returns Batchfile Transfers list
@return { Array }
*/
export const getBatchfileTransferList = state => state.batchfileTransferList

 /** returns International Transfers Requests List get more
@return { Array }
*/
export const getBatchfileTransferListHasMore = state => {
    return state.batchfileTransferListHasMore
}

/** returns Favorites List
@return { Array }
*/
export const getFavoritesList = state => {
    return state.favoritesList
}

/** returns Favorites hasMore value
@return { Boolean }
*/
export const getFavoritesListHasMore = state => state.favoritesHasMore

 /** returns Operation Types
@return { Array }
*/
export const getBatchfileOperationTypes = state => state.operationTypes

 /** returns Batchfile Transfer Type List
@return { Array }
*/
export const getBatchfileTransferTypeList = state => state.batchfileTransferTypeList

 /** returns Batchfile Categories List
@return { Array }
*/
export const getBatchfileCategoriesList = state => state.batchfileCategoriesList

 /** returBs batchf ileMotives List
@return { Array }
*/
export const getBatchfileMotivesList = state => state.batchfileMotivesList
